import React from "react";
import { Select, Form, Tooltip } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';
import { labelStyle } from "../../@types/productInfo";
import './style.css';

const { Option } = Select;

interface SelectOptionProps {
  value: string | undefined;
  setValue: (value: string) => void;
  title: string;
  placeholder: string;
  options: { value: string; label: string }[];
  style?: React.CSSProperties;
  required?: boolean;
  rules?: object[];
  name?: string;
  prefix?: React.ReactNode;
  tooltipText?: string;
}

const SelectOption: React.FC<SelectOptionProps> = ({
  value,
  setValue,
  title,
  placeholder,
  options,
  style,
  required = false,
  rules = [],
  name,
  prefix,
  tooltipText, 
}) => {
  const handleChange = (value: string) => {
    setValue(value);
  };

  return (
    <div>
      <div className="flex items-center gap-2">
        <p
          style={{
            ...(labelStyle as React.CSSProperties),
            color: required && !value ? "#005D6E" : "#005D6E",
            margin: 0, 
            display: 'flex', 
            alignItems: 'center', 
          
          }}
        >
          {title} {required && <span style={{ color: "#75A7AD", marginLeft: '4px' }}>*</span>}
        </p>
        {tooltipText && (
          <Tooltip title={tooltipText}>
            <InfoCircleOutlined 
              className="text-[#005D6E] cursor-pointer" 
              style={{ 
                fontSize: '14px', 
                display: 'flex', 
                alignItems: 'center',
                marginTop: '1px'
              }}
            />
          </Tooltip>
        )}
      </div>

      <Form.Item
        name={name}
        rules={
          rules.length ? rules : [{ required, message: `${title} is required` }]
        }
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {prefix && <span style={{ marginRight: "8px" }}>{prefix}</span>}
          <Select
            style={{
              width: "100%",
              ...style,
              height: "40px",
              borderRadius: "90px",
                marginTop:"10px"
            }}
            value={value}
            placeholder={value ? value : placeholder}
            onChange={handleChange}
          >
            {options.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </div>
      </Form.Item>
    </div>
  );
};

export default SelectOption;